import { createSlice } from "@reduxjs/toolkit";
import { getSubscribedUserReportsAction } from "../actions/adminDashboardAction";
import { InitialState } from "features/adminUserManagement/interfaces/userManagement.interface";

const initialState: InitialState = {
  data: null,
  isLoading: false,
};

const subscribedUsers = createSlice({
  name: "Subscribed User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSubscribedUserReportsAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSubscribedUserReportsAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getSubscribedUserReportsAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default subscribedUsers.reducer;
